function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import ConformanceTooltip from './conformanceTooltip';
import { conformanceSelector, enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import SinglePicker from '../../common/controls/singlePicker';
import useLookup from '../../../utils/useLookup';
import logValueOnChange from '../commonActions/logValueOnChange';
const prepareOptions = list => {
  const result = list.map(item => ({
    id: item.id,
    title: item.name
  }));
  return result;
};
const PhaseCodePickerField = ({
  conformanceText: _conformanceText = null,
  enabled,
  jobPhaseCode: {
    indexQuery,
    list
  },
  jobPhaseCodeActions: {
    serverFilter
  },
  jobID,
  label: incomingLabel = 'Phase Code',
  onChange,
  value: _value = '',
  path
}) => {
  const label = useLookup(incomingLabel);
  const showConformance = !!_conformanceText;
  useEffect(() => {
    // The serverFilter jobID filter is unused (params.filters.jobID) but will trigger reloads
    // as necessary when jobs change. indexQuery.jobID (params.jobID) is what the server uses.
    // Unfortunately there are a few dependencies in the web app that make changing this hard.
    const updatedIndexQuery = _objectSpread(_objectSpread({}, indexQuery), {}, {
      jobID
    });
    serverFilter({
      jobID
    }, updatedIndexQuery);
  }, [jobID, indexQuery, serverFilter] // server filter and index query should never change
  );
  const handleChange = useCallback(incomingValue => {
    const displayValue = incomingValue ? incomingValue.title : null;
    onChange({
      path,
      value: incomingValue,
      displayValue
    });
  }, [onChange, path]);
  const id = `pcpf-${kebabCase(label)}`;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    "data-testid": id
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    placeholder: `Select ${useLookup('Phase Code')}`,
    label: label,
    labelKey: "title",
    options: prepareOptions(list),
    onChange: handleChange,
    value: _value,
    valueKey: "id",
    className: `${showConformance ? 'is-invalid' : ''} t-pcpf`,
    disabled: !enabled //  single picker is a basic compoent, not FB
    ,
    verticalPadding: false
  }), /*#__PURE__*/React.createElement(ConformanceTooltip, {
    errorText: _conformanceText,
    target: id,
    placement: "right"
  }));
};
PhaseCodePickerField.propTypes = {
  conformanceText: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  jobID: PropTypes.string.isRequired,
  jobPhaseCode: PropTypes.shape({
    indexQuery: PropTypes.shape({
      jobID: PropTypes.string
    }).isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobPhaseCodeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
};
export { PhaseCodePickerField as UncomposedPhaseCodePickerField };
export default entityComposition(PhaseCodePickerField, ['jobPhaseCode'], {
  conformanceText: conformanceSelector,
  enabled: enabledSelector,
  jobID: state => state.report.active.jobID,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});